import { render, staticRenderFns } from "./JoinCustomer.vue?vue&type=template&id=1178cb5e&scoped=true&"
import script from "./JoinCustomer.vue?vue&type=script&lang=js&"
export * from "./JoinCustomer.vue?vue&type=script&lang=js&"
import style0 from "./JoinCustomer.vue?vue&type=style&index=0&id=1178cb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1178cb5e",
  null
  
)

export default component.exports